











import CommentItem from './comment_item.vue'
import { ApiEvaluationEvaluateStoreListResponse } from '@/api'
import { defineClassComponent } from '@/hooks'
import { RequiredDeep } from 'vtils/types'

export default defineClassComponent<{
  value: RequiredDeep<ApiEvaluationEvaluateStoreListResponse>['list']
}>(
  {
    props: ['value'],
    components: {
      CommentItem,
    },
  },
  () => class {},
)
